export function mayusculas(valor) {
  if (valor == null) return ''
  const texto = Array.isArray(valor) ? valor.filter((v) => v != null && v !== '').join(' ') : valor
  return String(texto).toUpperCase()
}
